/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import {
  createStackNavigator,
  CardStyleInterpolators,
} from '@react-navigation/stack';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import { setTitleHeader, setDefaultStackOption } from '@global/helpers';
import HamburgerButton from '@components/navbar/HamburgerButton';
import NotificationSettingButton from '@components/navbar/NotificationSettingButton';
import MatrixApprovalScreen from '@/screens/setting/matrix-approval/MatrixApprovalScreen';
import MatrixApprovalDetailScreen from '@/screens/setting/matrix-approval/MatrixApprovalDetailScreen';

const Stack = createStackNavigator();

const MatrixApprovalNavigator = ({ navigation }) => {
  const insets = useSafeAreaInsets();
  return (
    <Stack.Navigator
      initialRouteName="MatrixApprovalScreen"
      screenOptions={(props) => ({
        headerLeft: () => <HamburgerButton {...props} />,
        headerRight: () => <NotificationSettingButton {...props} />,
        ...setDefaultStackOption(insets, CardStyleInterpolators),
      })}>
      <Stack.Screen
        name="MatrixApprovalScreen"
        component={MatrixApprovalScreen}
        options={(props) => ({
          title: setTitleHeader('Matrix Approval'),
        })}
      />
      <Stack.Screen
        name="MatrixApprovalDetailScreen"
        component={MatrixApprovalDetailScreen}
        options={(props) => {
          const route = props.route;
          let title = 'Edit Matrix Approval';
          if (route.params?.id == 'add') {
            title = 'Add Matrix Approval';
          } else if (route.params?.id == 'view') {
            title = 'View Matrix Approval';
          }
          return {
            title: setTitleHeader(title),
            headerRight: () => false,
          };
        }}
      />
    </Stack.Navigator>
  );
};

MatrixApprovalNavigator.propTypes = {
  navigation: PropTypes.object,
};

MatrixApprovalNavigator.defaultProps = {
  navigation: {},
};

export default MatrixApprovalNavigator;
